import { createListCollection } from '@chakra-ui/react';

// Tone Ratings for
export const toneRatings = [
    { value: '0', description: 'No increase in muscle tone' },
    {
        value: '1',
        description:
            'Slight increase in muscle tone, manifested by a catch and release or by minimal resistance at the end of the range of motion when the affected part(s) is moved in',
    },
    {
        value: '1+',
        description:
            'Slight increase in muscle tone, manifested by a catch, followed by minimal resistance throughout the remainder (less than half) of the ROM (range of movement)',
    },
    { value: '2', description: 'More marked increase in muscle tone through most of the ROM, but affect part(s) easily moved' },
    { value: '3', description: 'Considerable increase in muscle tone passive, movement difficult' },
    { value: '4', description: 'Affected part(s) rigid in flexion or extension' },
];

export const painScaleRating = [
    {
        value: 'None',
        description: 'No rebound',
    },
    {
        value: '0',
        description: 'No pain',
    },
    {
        value: '5',
        description: 'Moderate',
    },
    {
        value: '10',
        description: 'Worst pain possible',
    },
];

// Movement Ratings in motor control in clinical impairments
export const movementRatings = [
    { value: 'WNL', description: 'Gravity eliminated/slight resist. or < 1/2 range against gravity' },
    { value: 'WFL', description: 'More than 1/2 but < Full ROM, against gravity' },
    { value: 'Ataxic', description: 'Maintain static sitting/standing balance with minimal challenges from all directions' },
    { value: 'Mild', description: 'No visible or palpable contraction' },
    { value: 'Moderate', description: 'Visible or palpable contraction (No ROM)' },
    { value: 'Extreme', description: 'Partial ROM, gravity eliminated' },
];

// Static Balance Legend in balance in clinical impairments
export const staticBalanceLegend = [
    { value: 'N', description: 'Maintain static sitting/standing with maximum challenges from all directions' },
    { value: 'G', description: 'Maintain static sitting/standing with moderate challenges from all directions' },
    { value: 'F+', description: 'Maintain static sitting/standing balance with minimal challenges from all directions' },
    { value: 'F', description: 'Able to sit/stand unsupported without balance loss or UE support' },
    { value: 'F-', description: 'Maintain static sitting/standing balance with CG assist' },
    { value: 'P+', description: 'Maintain static sitting/standing balance with minimal assist' },
    { value: 'P', description: 'Maintain static sitting/standing balance with moderate assist' },
    { value: 'P-', description: 'Maintain static sitting/standing balance with maximum assist' },
    { value: 'U', description: 'Unable to attempt' },
];

// Dynamic Balance Legend in balance in clinical impairments
export const dynamicBalanceLegend = [
    { value: 'N', description: 'Maintain dynamic sitting/standing balance through maximum excursions of active trunk movement' },
    { value: 'G', description: 'Maintain dynamic sitting/standing balance through moderate excursions of active trunk movement' },
    { value: 'F+', description: 'Maintain dynamic sitting/standing balance through minimal excursions of active trunk movement' },
    {
        value: 'F',
        description: 'Maintain dynamic sitting/standing balance through minimal excursions of active trunk movement with supervision',
    },
    {
        value: 'F-',
        description: 'Maintain dynamic sitting/standing balance through minimal excursions of active trunk movement with CG assist',
    },
    {
        value: 'P+',
        description: 'Maintain dynamic sitting/standing balance through minimal excursions of active trunk movement with minimal assist',
    },
    {
        value: 'P',
        description: 'Maintain dynamic sitting/standing balance through minimal excursions of active trunk movement with moderate assist',
    },
    {
        value: 'P-',
        description: 'Maintain dynamic sitting/standing balance through minimal excursions of active trunk movement with maximum assist',
    },
    { value: 'U', description: 'Unable to attempt' },
];

// Edema Ratings for integument in clinical impairments
export const edemaRatings = [
    { value: 'None', description: 'No rebound' },
    { value: '+1', description: 'Grade 1: Immediate rebound with 2 millimeter (mm) pit.' },
    { value: '+2', description: 'Grade 2: Less than 15-second rebound with 3 to 4 mm pit.' },
    { value: '+3', description: 'Grade 3: Rebound greater than 15 seconds but less than 60 seconds with 5 to 6 mm pit.' },
    { value: '+4', description: 'Grade 4: Rebound between 2 to 3 minutes with an 8 mm pit.' },
];

// Strength Ratings for strength card in clinical impairments
export const strengthRatings = [
    { value: '0', description: 'No visible or palpable contraction' },
    { value: '1', description: 'Visible or palpable contraction (No ROM)' },
    { value: '2-', description: 'Partial ROM, gravity eliminated' },
    { value: '2', description: 'Partial ROM, gravity eliminated' },
    { value: '2+', description: 'Gravity eliminated/slight resist. or < 1/2 range against gravity' },
    { value: '3-', description: 'more than 1/2 but < Full ROM, against gravity' },
    { value: '3', description: 'Full ROM against gravity' },
    { value: '3+', description: 'Full ROM against gravity, slight resistance' },
    { value: '4-', description: 'Full ROM against gravity, moderate resistance' },
    { value: '4', description: 'Full ROM against gravity, mild resistance' },
    { value: '4+', description: 'Full ROM against gravity, almost full resistance' },
    { value: '5', description: 'Normal, maximal resistance' },
];

// Combined object with all scales, probably you don't need this, but it's here jic
export const clinicalAssessmentScales = {
    toneRatings,
    movementRatings,
    staticBalanceLegend,
    dynamicBalanceLegend,
    edemaRatings,
    strengthRatings,
};

//met levels for overall functional status

export const metLevels = [
    {
        mets: '0.0-1.0',
        exercise: 'Strolling 1-1.5 mph, 1 miles in 40-60min',
        recreational: 'Knitting; Playing cards; Sewing; Watching TV',
        occupational: 'Desk work; Driving auto/truck; Sitting doing light assembly; Typing; Using hand tools; writing',
        ADLs: 'Brushing hair/teeth; Light housework; Making bed; Partial bath; Polishing furniture; Washing clothes; Cooking; Driving car; Ironing; riding lawn mower; Scrubbing floor, walls, cars, windows; Showering',
    },
    {
        mets: '1.0-2.0',
        exercise: 'Strolling 1-1.5 mph, 1 mile in 40-60 min',
        recreational: 'Knitting; Playing cards; Sewing; Watching TV',
        occupational: 'Desk work; Driving auto/truck; Sitting doing light assembly; Typing; Using hand tools; Writing',
        ADLs: 'Brushing hair/teeth; Light housework; Making bed; Partial bath; Polishing furniture; Washing clothes; Cooking; Driving car; Ironing; Riding lawn mower; Scrubbing floor, walls, cars, windows; Showering',
    },
    {
        mets: '2.0-3.0',
        exercise: 'Walking 2.0-2.5 mph, 1 mile in 24-30 min',
        recreational: 'Horseback riding (walk); Light golf (power cart); Playing musical instrument; Shuffleboard; Woodworking',
        occupational: 'Bartending; Crane operation; Standing doing light or medium assembly; TV/auto/car repair; Working heavy levers',
        ADLs: 'Cleaning windows; Climbing stairs; Housework (slowly); Kneeling; Light work; Packing/unpacking; Power lawn mowing',
    },
    {
        mets: '3.0-4.0',
        exercise: 'Walking 3.0-4.0 mph, 1 mile in 15-20 min',
        recreational: 'Billiards; Bowling; Canoeing; Croquet; Fly fishing; Golf (pulling cart); Shopping; Volleyball (non-competitive)',
        occupational: 'Baling hay; Driving heavy truck; Heavy machine assembly; Janitorial work; Light welding; Operating large levers',
        ADLs: 'Raking leaves; Shoveling light loads',
    },
    {
        mets: '4.0-5.0',
        exercise: 'Walking 4.0-4.5 mph, 1 mile in 13-15 min',
        recreational:
            'Canoeing (4 m/hr); Gardening (digging); Skating (ice/roller); Social/square dancing; Softball/baseball (non-game); Stream fishing',
        occupational:
            'Building interior of house; Carrying trays/dishes; Farm work (sporadic); House painting; Lifting, carrying objects (20-40 lb); Light carpentry; Mechanic work',
        ADLs: 'Stocking shelves; Vacuuming; General housework',
    },
    {
        mets: '5.0-6.0',
        exercise: 'Walking/jogging 4.0-5.0 mph, 1 mile in 12-13 min',
        recreational:
            'Backpacking (light); Badminton; Hiking; Hunting; Horseback riding (trot); Skiing (cross country, 2.5 mph); Skiing (light downhill)',
        occupational:
            'Handyman work (moving, shoveling); Heavy carpentry; Putting in sidewalk; Exterior home building; Lifting, carrying objects (45-64 lb); Shoveling (10/min, 9 lb); Splitting wood',
        ADLs: 'Raking leaves; Lawn mowing (push mower); Snow shoveling (light snow)',
    },
    {
        mets: '6.0-7.0',
        exercise: 'Biking 10 mph; Walking 5 mph, 1 mile in 12 min',
        recreational: 'Badminton (competitive); Basketball (non-game); Canoeing (5 m/h); Swimming (breaststroke, 40 yd/min)',
        occupational: 'Ascending stairs with 17 lb load; Lifting, carrying (65-84 lb); Moving heavy furniture; Sawing',
        ADLs: 'Heavy household cleaning; Vacuuming vigorously',
    },
    {
        mets: '7.0-8.0',
        exercise: 'Jog/run 5.5 mph; Biking 12 mph',
        recreational: 'Rowing machine; Rope jumping (60-80 skips/min); Handball/squash/racquetball',
        occupational:
            'Lifting, carrying (85-100 lb); Moving heavy furniture (moving van work); Shoveling (14 lb scoops, 10 scoops/min); Using heavy tools',
        ADLs: 'Strenuous yard work; Shoveling snow (heavy)',
    },
    {
        mets: '8.0-9.0',
        exercise: 'Jog/run 6 mph; Football (competitive)',
        recreational: 'Mountain climbing; Soccer (non-team); Touch football; Tour skiing',
        occupational: 'Heavy labor; Lumberjack work; Ascending stairs carrying 54 lb load',
        ADLs: 'Shoveling (16 lb scoops)',
    },
    {
        mets: '9.0-10.0',
        exercise: 'Jog/run 6 mph, 1 mile in 10 min; Biking 13 mph',
        recreational: 'Swimming (breaststroke); Basketball (non-game); Sledding/tobogganing',
        ADLs: 'Extremely vigorous yard work',
    },
];

export const states = [
    '-',
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];

export const ADMIT_SOURCE = [
    { value: '1', label: '1. Non-Health Care Facility Point of Origin' },
    { value: '2', label: '2. Clinic of Physicians Office' },
    { value: '4', label: '4. Transfer from Hospital (Different Facility)' },
    { value: '5', label: '5. Transferred from Skilled Nursing Facility (SNF) or Intermediate Care Facility (ICF)' },
    { value: '6', label: '6. Transfer from Another Health Care Facility' },
    { value: '8', label: '8. Court/Law enforcement' },
    { value: '9', label: '9. Information Not Available' },
];

export const ADMIT_TYPE = [
    { value: '1', label: '1. Emergency' },
    { value: '2', label: '2. Urgent' },
    { value: '3', label: '3. Elective' },
    { value: '4', label: '4. Newborn' },
    { value: '5', label: '5. Trauma' },
    { value: '9', label: '9. Information Unavailable' },
];

export const ADMIT_STATUS = [
    {
        value: '01',
        label: '01. Discharge to home or self-care (routine discharge)',
    },
    {
        value: '02',
        label: '02. Discharge/transfer to short-term general hospital',
    },
    {
        value: '03',
        label: '03. Discharge/transfer to SNF',
    },
    {
        value: '04',
        label: '04. Discharge/transfer to ICF',
    },
    {
        value: '05',
        label: "05.Discharge/transfer to a designed cancer center or children's hospital",
    },
    {
        value: '06',
        label: '06. Discharge/transfer to home care of another HHA OR discharge and readmit to the same HHA withina 60-day episode',
    },
    {
        value: '07',
        label: '07. Left against medical advice or discontinue care',
    },
    {
        value: '20',
        label: '20. Expired. Occurrence coe 55 also required',
    },
    {
        value: '21',
        label: '21. Discharge/transfer to court/law enforcement',
    },
    {
        value: '30',
        label: '30. Still a patient. Services continue to be provided. (Required on RAPS.)',
    },
    {
        value: '43',
        label: '43. Discharge/transfer to a federal hospital',
    },
    {
        value: '50',
        label: '50. Discharge/transfer for hospice services in the home',
    },
    {
        value: '51',
        label: '51. Discharge/transfer to hospice services in a medical facility',
    },
    {
        value: '62',
        label: '62. Discharge/transfer to IRF (Inpatient Rehabilitation Facility)',
    },
    {
        value: '63',
        label: '63. Discharge/transfer to long-term care hospital',
    },
    {
        value: '65',
        label: '65. Discharge/transfer to psychiatric hospital or psychiatric part unit of a hospital',
    },
    {
        value: '66',
        label: '66. Discharge/transfer to Critical Access Hospital (CAH)',
    },
    {
        value: '70',
        label: '70. Discharge/transfer to another type of health care institution not defined elsewhere in code list',
    },
];

export const CARE_LOCATION = [
    {
        value: 'Q5001',
        label: "Q5001. Care provided in patient's home/residence",
    },
    {
        value: 'Q5002',
        label: 'Q5002. Care provided assisted living facility',
    },
    {
        value: 'Q5009',
        label: 'Q5009. Care provided in place not otherwise specified (NO)',
    },
];

export const accreditationBodies = [
    '',
    'The Joint Commission (TJC)',
    'Community Health Accreditation Program, Inc. (CHAP) ',
    'Accreditation Commission for Health Care, Inc. (ACHC) ',
];

export const painScale = Array.from({ length: 10 }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
}));

export const painScaleOptions = createListCollection({
    items: Array.from({ length: 10 }, (_, i) => ({
        value: (i + 1).toString(),
        label: (i + 1).toString(),
    })),
});

export const OCCURRENCE_CODES = [
    { value: '50', label: '50 - OASIS Completion date (M0090)' },
    {
        value: '61',
        label: '61 - The "Through" date of an acute care hospital discharge within 14 days prior to the "From" date of any home health claim',
    },
    {
        value: '62',
        label: '62 - The "Through" date of a SNF, IRF, LTCH, or IPF discharge within 14 days prior to the admission date of the first home health claim.',
    },
];

export const taskTypes = [
    { value: 'teaching', label: 'Teaching' },
    { value: 'assessment', label: 'Assessment' },
    { value: 'intervention', label: 'Intervention' },
];

export const disciplines = [
    { value: 'SN', label: 'SN' },
    { value: 'HHA', label: 'HHA' },
    { value: 'MSW', label: 'MSW' },
    { value: 'PT', label: 'PT' },
    { value: 'OT', label: 'OT' },
    { value: 'ST', label: 'ST' },
    { value: 'OTH', label: 'OTH' },
];

export const problemTypes = [
    {
        label: 'General',
        value: 'General',
    },
    {
        label: 'Vital Signs',
        value: 'Vital Signs',
    },
    {
        label: 'Immunizations',
        value: 'Immunizations',
    },
    {
        label: 'Infusion Therapy',
        value: 'Infusion Therapy',
    },
    {
        label: 'Nutrition Assessment',
        value: 'Nutrition Assessment',
    },
    {
        label: 'Gastrointestinal',
        value: 'Gastrointestinal',
    },
    {
        label: 'Elimination',
        value: 'Elimination',
    },
    {
        label: 'Living Arrangements',
        value: 'Living Arrangements',
    },
    {
        label: 'Sensory',
        value: 'Sensory',
    },
    {
        label: 'Pain Assessment',
        value: 'Pain Assessment',
    },
    {
        label: 'Integumentary',
        value: 'Integumentary',
    },
    {
        label: 'Cardiovascular',
        value: 'Cardiovascular',
    },
    {
        label: 'Respiratory',
        value: 'Respiratory',
    },
    {
        label: 'Behavioral',
        value: 'Behavioral',
    },
    {
        label: 'Musculoskeletal',
        value: 'Musculoskeletal',
    },
    {
        label: 'ADL',
        value: 'ADL',
    },
    {
        label: 'Medications',
        value: 'Medications',
        disciplines: ['PT', 'SN'],
    },
    {
        label: 'Emergent Care',
        value: 'Emergent Care',
    },
    {
        label: 'Therapy',
        value: 'Therapy',
    },
    {
        label: 'Functional',
        value: 'Functional',
    },
    {
        label: 'Neurological',
        value: 'Neurological',
    },
    {
        label: 'Genitourinary',
        value: 'Genitourinary',
    },
    {
        label: 'Endocrine ',
        value: 'Endocrine ',
    },
    {
        label: 'Wound Care ',
        value: 'Wound Care ',
    },
];

export const templateTypeOptions = [
    {
        label: 'Problem',
        value: 'problem',
    },
    {
        label: 'Goal',
        value: 'goal',
    },
    {
        label: 'Task',
        value: 'task',
    },
    {
        label: 'Summary',
        value: 'summary',
    },
    {
        label: 'Medication - Purpose / Instructions',
        value: 'medication-purpose',
    },
    {
        label: 'Medication - Side Effects',
        value: 'medication-side-effect',
    },
    {
        label: 'Physician Order - Subject',
        value: 'physician-order-subject',
    },
    {
        label: 'Physician Order - Description',
        value: 'physician-order-description',
    },
];
